import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { openServerManual } from '@/api/gmtool/packageCode';
import { tabulation, gmTool, serchSelect } from "@/mixins/index";
export default {
  mixins: [tabulation, gmTool, serchSelect],
  data: function data() {
    return {
      reqLoading: false,
      paramsData: {
        id: '',
        is_delay: "0",
        delay_time: ''
      },
      paramsDataMark: {},
      dialogShow: false,
      rules: {
        special_product_id: [{
          required: true,
          message: this.$t('selectProduct'),
          trigger: "blur"
        }],
        delay_time: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }]
      },
      isMobile: false
    };
  },
  created: function created() {
    this.paramsDataMark = _objectSpread({}, this.paramsData);
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    open: function open(data) {
      this.dialogShow = true;
    },
    clearData: function clearData(isClearId) {
      this.paramsData = _objectSpread(_objectSpread({}, this.paramsDataMark), {}, {
        id: isClearId ? '' : this.paramsData.id
      });
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.$confirm(_this.$t('confirmOpenServer'), _this.$t('tip'), {
            confirmButtonText: _this.$t('confirm'),
            cancelButtonText: _this.$t('cancel'),
            type: "warning"
          }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var loading;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    loading = _this.$loading({
                      lock: true,
                      text: _this.$t('sending'),
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                    });
                    openServerManual(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                      game_id: _this.rawData.game_id
                    })).then(function (res) {
                      loading.close();

                      if (res.code == 200) {
                        _this.$message({
                          message: _this.$t('operationSuccess'),
                          type: 'success'
                        });

                        _this.dialogShow = false;

                        _this.$emit('update');
                      }
                    }).finally(function () {
                      loading.close();
                    });

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));
        }
      });
    }
  }
};